import { IWcwSearchFormSchema } from '~/purchase/schemas';
import {
  ICreateSearchHistoryPayload,
  ICreateWcwSearchHistoryPayload,
  IBaseSearchFormSchema,
} from '~/purchase/types';

export const SEARCH_HISTORY_TYPE = {
  PURCHASE: 'PURCHASE',
  QUOTE: 'QUOTE',
} as const;
export const buildPurchasePayload = (
  searchQuery: IBaseSearchFormSchema,
): ICreateSearchHistoryPayload => {
  return {
    type: SEARCH_HISTORY_TYPE.PURCHASE,
    query: {
      identifiers: searchQuery.identifier?.value
        ? [searchQuery.identifier?.value]
        : undefined,
      width: searchQuery.width,
      height: searchQuery.height,
      diameter: searchQuery.diameter,
      includeHigherIndexes: Boolean(searchQuery.includeHigherIndexes),
      quantity: searchQuery.quantity,
      loadIndexes: searchQuery.loadIndexes,
      speedIndexes: searchQuery.speedIndexes,
      seasons: searchQuery.seasons ?? [],
      brands: searchQuery.brands ?? [],
      vehicleGroupCode: searchQuery.vehicleTypeGroup,
      fieldNameSearch: searchQuery.fieldNameSearch,
      vehicleTypeIds: searchQuery.vehicleTypes ?? [],
    },
  };
};
export const buildWcwSearchPayload = (
  searchQuery: IWcwSearchFormSchema,
): ICreateWcwSearchHistoryPayload => {
  return {
    query: {
      reference:
        searchQuery.identifier?.value ?? searchQuery.rawIdentifier ?? undefined,
      brand: searchQuery.brand ?? undefined,
      model: searchQuery.model ?? undefined,
      versions: searchQuery.versions ?? [],
      seasonPublicKeys: searchQuery.seasons,
      set: searchQuery.set ?? 4,
      vehicleGroupCode: searchQuery.vehicleTypeGroup,
    },
  };
};
export const buildQuotePayload = (
  searchQuery: IBaseSearchFormSchema,
): ICreateSearchHistoryPayload => {
  return {
    type: SEARCH_HISTORY_TYPE.QUOTE,

    query: {
      identifiers: searchQuery.identifier?.value
        ? [searchQuery.identifier?.value]
        : undefined,
      width: searchQuery.width,
      height: searchQuery.height,
      diameter: searchQuery.diameter,
      quantity: searchQuery.quantity,
      loadIndexes: searchQuery.loadIndexes,
      speedIndexes: searchQuery.speedIndexes,
      seasons: searchQuery.seasons ?? [],
      brands: searchQuery.brands ?? [],
      vehicleGroupCode: searchQuery.vehicleTypeGroup,
      fieldNameSearch: searchQuery.fieldNameSearch,
      vehicleTypeIds: searchQuery.vehicleTypes ?? [],
      includeHigherIndexes: Boolean(searchQuery.includeHigherIndexes),
    },
  };
};
